import EditActionSeconds from './EditActionSeconds'
import { connect } from 'react-redux'
import { setAnswerMs } from '../reducers/answerMs'


const mapStateToProps = (state) => ({
    label: 'risposta',
    seconds: Math.round(state.answerMs / 1000)
})

const mapDispatchToProps = (dispatch) => ({
    onSubmit: (seconds) => dispatch(setAnswerMs(seconds * 1000))
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditActionSeconds)


// WEBPACK FOOTER //
// ./src/components/EditAnswerSeconds.js